module.exports = __webpack_public_path__ + "static/media/other certificate.d67fc1d6.svg";